// @flow
import * as React from 'react'
import ReactModal from 'react-modal'
import DismissIcon from 'icon/DismissIcon'
import { type WidthConstraint, WIDTH_CONSTRAINTS } from './width_constraint'

import './Modal.scss'

type Props = {
  appearance?: 'basic' | 'bordered' | 'flush',
  title: string,
  contentLabel: string,
  className: string,
  isOpen: boolean,
  widthConstraint: WidthConstraint,
  centerContent: boolean,
  onRequestClose?: () => void,
  children: React.Node,
}

export default class Modal extends React.Component<Props> {
  static defaultProps = {
    title: '',
    contentLabel: '',
    className: '',
    isOpen: false,
    widthConstraint: WIDTH_CONSTRAINTS.NONE,
    centerContent: false,
  }

  render = () => {
    const contentLabel = this.props.contentLabel || this.props.title

    return (
      <ReactModal
        className={this.className}
        overlayClassName="Modal-overlay"
        contentLabel={contentLabel}
        isOpen={this.props.isOpen}
        onRequestClose={this.props.onRequestClose}
      >
        <div className="Modal-contentWrapper">
          {this.props.onRequestClose ? renderDismiss(this.props.onRequestClose) : null}
          <div className={this.headerClassName}>{this.renderTitle()}</div>
          <div className={this.bodyClassName}>{this.props.children}</div>
        </div>
      </ReactModal>
    )
  }

  renderTitle = () => {
    return this.props.title ? <div className="Modal-title">{this.props.title}</div> : null
  }

  get className(): string {
    const base = 'Modal-container'

    return [
      base,
      this.props.appearance ? `${base}--${this.props.appearance}` : '',
      widthConstraintModifier(base, this.props.widthConstraint),
      this.props.className,
    ].join(' ')
  }

  get headerClassName(): string {
    const base = 'Modal-header'

    return [base, !this.props.title ? `${base}--noTitle` : ''].join(' ')
  }

  get bodyClassName(): string {
    const base = 'Modal-body'

    return [base, this.props.centerContent ? `${base}--centerContent` : ''].join(' ')
  }
}

function renderDismiss(onRequestClose: () => void): React.Node {
  return (
    <div className="Modal-closeButton">
      <button className="Button Button--naked" onClick={onRequestClose}>
        <DismissIcon strokeColor="#979797" layout="inline" />
      </button>
    </div>
  )
}

function widthConstraintModifier(base, widthConstraint) {
  switch (widthConstraint) {
    case WIDTH_CONSTRAINTS.FULL:
      return `${base}--full`

    case WIDTH_CONSTRAINTS.TIGHT:
      return `${base}--tight`

    case WIDTH_CONSTRAINTS.MEDIUM:
      return `${base}--medium`

    default:
      return ''
  }
}
